import type { ParseKeys } from 'i18next';
import type { components } from '@/api/qraft/schema';

export type Language = components['schemas']['Language'];

/**
 * Translation keys for the display names of the backend `Language` enum.
 *
 * Typed as `Record<Language, string>` on purpose: the keys are pinned to the
 * generated `Language` union, so if the backend adds or removes a language and
 * the client is regenerated, this map stops type-checking until it's updated —
 * the labels can't silently drift from the source enum.
 */
export const LANGUAGE_LABELS = {
  EN: 'admin.languages.EN',
  ES: 'admin.languages.ES',
  FR: 'admin.languages.FR',
  PT_BR: 'admin.languages.PT_BR',
} as const satisfies Record<Language, ParseKeys>;

/** `[code, label key]` pairs for building selects/menus. */
export const LANGUAGE_OPTIONS = Object.entries(LANGUAGE_LABELS) as [
  Language,
  (typeof LANGUAGE_LABELS)[Language],
][];
